<template>
    <i class="vm-icon afd" :class="name ? 'afd-' + name : name"></i>
</template>

<script>

export default {
    name: 'icon',
    props: {
        name: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style lang="stylus" scoped>
.vm-icon{

}
</style>
